module.exports = __webpack_public_path__ + "static/the-tao-of-philosophy-0c54927d53ea167d59081399200a01c3.jpg";